import React, {
    Component
  } from 'react';

  import {
    connect
  } from 'react-redux';
  import Switch from '../../components/UI/Switch/Switch'
  import Tooltip from 'react-tooltip-lite';
  import { FaInfoCircle } from 'react-icons/fa';
  import classes from './MultipleAdvancedInHomeWifi.css';
  import Box from '../../hoc/Box/Box';
  import * as actions from '../../store/actions/index';
  import withErrorHandler from '../../hoc/withErrorHandler/withErrorHandler';
  import Spinner from '../../components/UI/Spinner/Spinner';
  import api from '../../axios-local-api';
  import Confirm from '../../components/UI/Confirm/Confirm';
  import Success from '../../components/UI/Success/Success';
  import Error from '../../components/UI/Error/Error';
  import Modal from '../../components/UI/Modal/Modal';
  
  
  export class MultipleAdvancedInHomeWifi extends Component {
    constructor(props) {
      super(props);
      this.state = {
        success:false,
        error:false,
        action:null,
        checked: this.props.isMultiRouterEnabled, 
        confirmModal:false,
        result: '',
        isDataUpdated: false
      }
      this.handleToggle = this.handleToggle.bind(this);
    }

    static getDerivedStateFromProps(props, prevState) {
      const state = {};
      if (!prevState.isDataUpdated && props.isLoaded) {
        state.isDataUpdated = true;
        state.checked = props.isMultiRouterEnabled;
      }    
      return state;
    }

    componentDidMount() {
      this.setState({
        checked: this.props.isMultiRouterEnabled
      });
    }

   handleToggle() {
      if (!this.state.checked) {
        const modalContent = (<div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
          <h2 style={{ whiteSpace: 'nowrap', marginBottom:'5px' }} className={classes.desktop_view}>Confirmation of Enabling?</h2>
          <p style={{ fontWeight: 'normal', textAlign: 'center', margin:'5px 24px' }}>Only enable this feature if the customer is experiencing reboot issues related to having Multiple AIHW routers installed.</p>
          <p style={{ fontWeight: 'normal', margin: 0, textAlign: 'center' }}>Are you sure you want to perform the configuration change?</p>
  
        </div>)
        this.onOpenModal(modalContent, 'change MultiAdvHomeWifi');
      } else {
        const modalContent = (<div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
          <h2 style={{ whiteSpace: 'nowrap', marginBottom:'5px' }} className={classes.desktop_view}>Confirmation of Disabling?</h2>
          <p style={{ fontWeight: 'normal', textAlign: 'center', margin:'5px 24px' }}>Disabling the feature may cause the customers router to not the function properly. </p>
          <p style={{ fontWeight: 'normal', margin: 0, textAlign: 'center' }}>Are you sure you want to perform the configuration change?</p>
        </div>)
        this.onOpenModal(modalContent, 'change MultiAdvHomeWifi');
      }
  
  
      this.setState((state) => ({ checked: !state.checked }));
     
    }
    successErrorResetHandler = () => {
      this.props.resetMultiRouterErrorSuccess();
    }
    confirmModalConfirmHandler = () => {
      if (this.state.checked) {
        this.props.createMultipleadvancedHomeWifi( this.props.soloId );
      } else {
        this.props.deleteMultipleadvancedHomeWifi( this.props.soloId );
      }
      
      this.closeModal('dontreset');
    }
    confirmModalCancelHandler = () => {
      this.setState({ confirmModal:false, checked: this.props.isMultiRouterEnabled });
      
    }
    closeModal= (event) => {
      this.setState({ confirmModal:false });
      if (event !== 'dontreset') {
        this.setState({ checked: this.props.isMultiRouterEnabled });
      }
    }
    onOpenModal= (result, action) =>{
      this.setState({
        confirmModal:true,
        action,
        result
      })
    }
    
  
    render() {
 
  
      if (this.props.loading) {
  
        return (
            <Spinner />
        )
      } else{
      
        return (
          <Box>
            <div className={classes.MultipleAdvancedWifi}>
              <div className={classes.TitleArea}>
              <h3> Multiple Advanced In-Home WiFi Networks </h3>
              <div id = "ExclusionToggle" className={[classes.desktop_view, classes.switchclass].join(' ')}

            onMouseOver={() => {
                  if (!this.props.soloId) {
                    this.setState({
                      showTooltip: !this.state.showTooltip
                    });
                  }
                }}
                onMouseOut={() => {
                  if (!this.props.soloId) {
                    this.setState({
                      showTooltip: false
                    });
                  }
                }}
              >
                {this.state.showTooltip && 
                  <span className={classes.tooltipclass}>Customer is outside Charter network footprint.</span>
                }
                  <Switch
                    aria-checked={this.state.checked}
                    className={classes.desktop_view}
                    aria-label="Toggle MAIHWN"
                    onChange={this.handleToggle}
                    disabled={!(this.props.soloId)}
                    checked={this.state.checked}
                  />
              </div>
              </div>
            <div className={[classes.alertMessageContainer, classes.desktop_view].join(' ')}>
                <span className={classes.desktop_view}><FaInfoCircle color="#38a9f9" size={24}/></span>
                <span className={classes.mobile_view}><FaInfoCircle color="#38a9f9" size={16}/></span>
                <span className={classes.alertMessage}>Only enable for customers who have multiple AIHW routers continuously rebooting. This does not provide multi-network management. </span>
            </div>
            <div className={[classes.alertMessageContainer, classes.mobile_view].join(' ')}>
                <span className={classes.mobile_view}><FaInfoCircle color={!this.props.soloId ? 'orange': '#38a9f9'} size={16}/></span>
                <span className={classes.alertMessage}>
              {this.props.soloId ?`Only enable for customers who have multiple AIHW routers continuously rebooting. 
              This does not provide multi-network management.` : 'This feature is not supported for customers who use services outside of charter footprint'} </span>
            </div>
            <div className={[classes.mobile_view, classes.switchclass].join(' ')}>
                <Switch
                  className={classes.mobile_view}
                  aria-checked={this.state.checked}
                  aria-label="Toggle MAIHWN"
                  onChange={this.handleToggle}
                  disabled={!(this.props.soloId)}
                  checked={this.state.checked}
                />
              </div>
            </div>
            <div id = "ExclusionList" className={classes.desktop_view}>
                <Modal deviceGroupConfirmation="true" show={this.state.confirmModal} modalClosed={this.closeModal}>
                  <Confirm id = {'MultiAdvancedInHomeWifiConfirm'}
                  action={this.state.action}
                  result={this.state.result}
                  deviceGroupConfirmation
                  confirm={this.confirmModalConfirmHandler}
                  cancel={this.confirmModalCancelHandler}
                  cancelButtonLabel="Cancel"
                  confirmButtonLabel={this.state.checked ? 'Enable':'Disable'}
                  hideActionText={true}
                  />
              </Modal>
            </div>
            <div id = "ExclusionList" className={classes.mobile_view}>
            <Modal show={this.state.confirmModal} modalClosed={this.closeModal}>
                <Confirm 
                action={this.state.action}
                result={this.state.result}
                confirmMsgStyling
                confirm={this.confirmModalConfirmHandler}
                cancel={this.confirmModalCancelHandler}
                cancelButtonLabel="CANCEL"
                confirmButtonLabel={this.state.checked ? 'ENABLE' : 'DISABLE'}
                hideActionText={true}
                />
            </Modal>
            </div>
           
          <Modal show={this.props.error} modalClosed={this.successErrorResetHandler}>
             <Error id = {'MultipleAdvancedHomeWifiError'} showOldView/>
          </Modal>
          <Modal show={this.props.success} modalClosed={this.successErrorResetHandler}>
             <Success id = {'MultipleAdvancedHomeWifiSuccess'}/>
          </Modal>
          </Box>
        )
      }
    }
  }
  
  const mapStateToProps = (state => {
    return {
      loading: state.multiAdvanced.loading,
      success:state.multiAdvanced.success,
      error: state.multiAdvanced.error,
      soloId: state.multiAdvanced.soloId,
      isMultiRouterEnabled: state.multiAdvanced.isMultiRouterEnabled,
      isLoaded: state.multiAdvanced.isLoaded
    };
  });
  
  const mapDispatchToProps = (dispatch) => {
    return {
      resetMultiRouterErrorSuccess: () => dispatch(actions.resetMultiRouterErrorSuccess()),
      createMultipleadvancedHomeWifi: (soloId) => dispatch(actions.createMultipleadvancedHomeWifi(soloId)),
      deleteMultipleadvancedHomeWifi: (soloId) => dispatch(actions.deleteMultipleadvancedHomeWifi(soloId))
    }
  }
  
  export default connect(mapStateToProps, mapDispatchToProps)(withErrorHandler(MultipleAdvancedInHomeWifi, api));
  